import React from 'react';
import * as classes from './Quote.module.scss'
import MediaQuery from 'react-responsive';
import { getFileName } from '../../helpers/FileCatching';
import { trackCustomEvent } from "../../helpers/tracking";

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function Quote({content, GlobalData}) {

    function onPromoClick(link){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Click",
          label: "Discover more " + link
        }
        trackCustomEvent(trackObject);
    }

    let copy = 
        <div className={`${classes.Quote__contentContainer}`}>
            <div className={`${classes.Quote__contentContainer__copy}`}>
                <h1>{content.quote}</h1>
                <p>{content.biline}</p>
            </div>
            <div className={`${classes.Quote__contentContainer__quoteMarks}`}>
                <img src={getFileName(contentImages,content.quoteMarks).default} alt="quote marks" className={classes.Quote__contentContainer__quoteMarksImage}/>
            </div>

            <a href={content.ctaUrl} onClick={() => { onPromoClick(content.ctaUrl) }} className={`${classes.Quote__cta} button`}><p>{content.ctaText}</p></a>
        </div>
    
    
    return (
        <div className={`${classes.Quote}`}>
            <MediaQuery maxWidth={classes.screenMdMax}>
                <div className={`${classes.Quote__wrapper}`} style={{backgroundImage: `url(${getFileName(contentImages,content.backgroundImage.mobile).default})`}}>
                    {copy}
                    
                </div>
            </MediaQuery>
            <MediaQuery minWidth={classes.screenMd} maxWidth={classes.screenLgMax}>
                <div className={`${classes.Quote__wrapper}`} style={{backgroundImage: `url(${getFileName(contentImages,content.backgroundImage.tablet).default})`}}>
                    {copy}
                </div>
            </MediaQuery>
            <MediaQuery minWidth={classes.screenLg}>
                <div className={`${classes.Quote__wrapper}`} style={{backgroundImage: `url(${getFileName(contentImages,content.backgroundImage.desktop).default})`}}>
                    {copy}
                </div>
            </MediaQuery>

        </div>
    );
}

export default Quote;